import { Injectable } from '@angular/core';
// import {MedicalCategory} from '../../models/medical-category';

@Injectable()
export class NodeService {

  constructor() { }

  getNode(node: any): any {
    return {
      'label': node.name,
      'expandedIcon': 'pi pi-folder-open',
      'collapsedIcon': 'pi pi-folder',
      'data': {
        'category': node
      },
      'children': [],
      'leaf': false
    }
  }

  getLeaf(leaf: any): any {
    return {
      'label': leaf.name,
      'icon': 'fas fa-file-medical',
      'data': {
        'category': leaf
      },
      'leaf': true
    }
  }

}
